import React from "react";

import ChecklistSubtitle from "./Subtitle";
import ChecklistCheckbox from "./Checkbox";
import ChecklistDemoGroup from "./DemoGroup";

const ChecklistBrandDemographics = ({
  brandDemographic,
  selectedBrandDemographics,
  handleClearDemographicSelection,
  handleSelectDemographicGroup,
  handleSelectDemographicOption,
  totalSelected
}) => (
  <div className="checklist-brand-demographics">
    {brandDemographic.demoGroups.map((group) => (
      <section key={group.name} className="checklist-demo-group">
        <ChecklistSubtitle subtitle="Select by Region" />
        <fieldset>
          {group.groupValues.map((value) => (
            <ChecklistDemoGroup
              key={`demo-group-val-${value.demographicGroupValueId}`}
              value={value}
              brandDemographic={brandDemographic}
              selectedBrandDemographics={selectedBrandDemographics}
              onClick={() =>
                handleSelectDemographicGroup(brandDemographic.demographicId, group.demographicGroupId, value)
              }
            />
          ))}
        </fieldset>
      </section>
    ))}
    <section className="checklist-checkbox-section">
      <div className="checklist-checkbox-header">
        <ChecklistSubtitle
          subtitle={`Select by ${brandDemographic.demographicId === 1 ? "Country" : brandDemographic.name}`}
          totalSelected={totalSelected}
        />
        <button
          className="checklist-checkbox-clear-btn"
          type="button"
          onClick={() => handleClearDemographicSelection(brandDemographic)}
        >
          Clear Selections <i className="fa-regular fa-circle-xmark" />
        </button>
      </div>
      <fieldset className="checklist-checkbox-fieldset">
        {brandDemographic.brandDemos.map((demo) => (
          <ChecklistCheckbox
            key={demo.name}
            name={demo.name}
            label={demo.name}
            onChange={(e) =>
              handleSelectDemographicOption(brandDemographic.demographicId, demo.demographicValueId, e.target.checked)
            }
            checked={demo.checked}
          />
        ))}
      </fieldset>
    </section>
  </div>
);
export default ChecklistBrandDemographics;
